import React from 'react';
import { demoMessage, isDemoUser } from '../DemoImport/utils';
import { Button } from '../Button/Button';
import { IconButton } from '../Button/IconButton';

type ActionButtonProps = {
	label: string | React.ReactElement;
	icon?: React.ReactNode | React.ReactNode[];
	useIconButton?: boolean;
	demoAllow?: boolean;
	demoBlock?: boolean;
};

export function ActionButton({ label, demoAllow, demoBlock, useIconButton, ...rest }: ActionButtonProps & Parameters<typeof Button>[0]) {
	const { icon } = rest; // Leave icon within rest in case it should be passed to Button
	let { onClick } = rest;
	if (isDemoUser()) {
		const blockLabel = ['ok', 'save', 'submit'].indexOf(label?.toLowerCase?.() || '') >= 0;
		if ((blockLabel && !demoAllow) || demoBlock) {
			onClick = demoMessage;
		}
	}
	return icon && useIconButton
		? <IconButton icon={icon} tooltip={typeof label === 'string' ? label : null} {...rest} {...(onClick && { onClick })} />
		: <Button {...rest} {...(onClick && { onClick })}>{label}</Button>;
}
